/* jshint ignore:start */
import Component from 'metal-component';
import Soy from 'metal-soy';

var templates;
goog.loadModule(function(exports) {
var soy = goog.require('soy');
var soydata = goog.require('soydata');
// This file was automatically generated from ClayActionsDropdown.soy.
// Please don't edit this file by hand.

/**
 * @fileoverview Templates in namespace ClayActionsDropdown.
 * @public
 */

goog.module('ClayActionsDropdown.incrementaldom');

goog.require('goog.soy.data.SanitizedContent');
goog.require('soy.asserts');
var soyIdom = goog.require('soy.idom');

var $templateAlias2 = Soy.getTemplate('ClayDropdownBase.incrementaldom', 'render');

var $templateAlias1 = Soy.getTemplate('ClayIcon.incrementaldom', 'render');


/**
 * @param {{
 *  items: !Array<?>,
 *  spritemap: (!goog.soy.data.SanitizedContent|string),
 *  _handleButtonClick: (*|null|undefined),
 *  _handleItemClick: (*|null|undefined),
 *  button: (?),
 *  caption: (!goog.soy.data.SanitizedContent|function()|null|string|undefined),
 *  disabled: (boolean|null|undefined),
 *  elementClasses: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  expanded: (boolean|null|undefined),
 *  helpText: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  id: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  itemsIconAlignment: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  preferredAlign: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  toggle: (*|null|undefined),
 *  triggerAriaLabel: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  triggerClasses: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  triggerTitle: (!goog.soy.data.SanitizedContent|null|string|undefined)
 * }} opt_data
 * @param {Object<string, *>=} opt_ijData
 * @param {Object<string, *>=} opt_ijData_deprecated
 * @return {void}
 * @suppress {checkTypes}
 */
function $render(opt_data, opt_ijData, opt_ijData_deprecated) {
  opt_ijData = opt_ijData_deprecated || opt_ijData;
  /** @type {!Array<?>} */
  var items = soy.asserts.assertType(goog.isArray(opt_data.items), 'items', opt_data.items, '!Array<?>');
  /** @type {!goog.soy.data.SanitizedContent|string} */
  var spritemap = soy.asserts.assertType(goog.isString(opt_data.spritemap) || opt_data.spritemap instanceof goog.soy.data.SanitizedContent, 'spritemap', opt_data.spritemap, '!goog.soy.data.SanitizedContent|string');
  /** @type {*|null|undefined} */
  var _handleButtonClick = opt_data._handleButtonClick;
  /** @type {*|null|undefined} */
  var _handleItemClick = opt_data._handleItemClick;
  /** @type {?} */
  var button = opt_data.button;
  /** @type {!goog.soy.data.SanitizedContent|function()|null|string|undefined} */
  var caption = soy.asserts.assertType(opt_data.caption == null || goog.isFunction(opt_data.caption) || (goog.isString(opt_data.caption) || opt_data.caption instanceof goog.soy.data.SanitizedContent), 'caption', opt_data.caption, '!goog.soy.data.SanitizedContent|function()|null|string|undefined');
  /** @type {boolean|null|undefined} */
  var disabled = soy.asserts.assertType(opt_data.disabled == null || (goog.isBoolean(opt_data.disabled) || opt_data.disabled === 1 || opt_data.disabled === 0), 'disabled', opt_data.disabled, 'boolean|null|undefined');
  /** @type {!goog.soy.data.SanitizedContent|null|string|undefined} */
  var elementClasses = soy.asserts.assertType(opt_data.elementClasses == null || (goog.isString(opt_data.elementClasses) || opt_data.elementClasses instanceof goog.soy.data.SanitizedContent), 'elementClasses', opt_data.elementClasses, '!goog.soy.data.SanitizedContent|null|string|undefined');
  /** @type {boolean|null|undefined} */
  var expanded = soy.asserts.assertType(opt_data.expanded == null || (goog.isBoolean(opt_data.expanded) || opt_data.expanded === 1 || opt_data.expanded === 0), 'expanded', opt_data.expanded, 'boolean|null|undefined');
  /** @type {!goog.soy.data.SanitizedContent|null|string|undefined} */
  var helpText = soy.asserts.assertType(opt_data.helpText == null || (goog.isString(opt_data.helpText) || opt_data.helpText instanceof goog.soy.data.SanitizedContent), 'helpText', opt_data.helpText, '!goog.soy.data.SanitizedContent|null|string|undefined');
  /** @type {!goog.soy.data.SanitizedContent|null|string|undefined} */
  var id = soy.asserts.assertType(opt_data.id == null || (goog.isString(opt_data.id) || opt_data.id instanceof goog.soy.data.SanitizedContent), 'id', opt_data.id, '!goog.soy.data.SanitizedContent|null|string|undefined');
  /** @type {!goog.soy.data.SanitizedContent|null|string|undefined} */
  var itemsIconAlignment = soy.asserts.assertType(opt_data.itemsIconAlignment == null || (goog.isString(opt_data.itemsIconAlignment) || opt_data.itemsIconAlignment instanceof goog.soy.data.SanitizedContent), 'itemsIconAlignment', opt_data.itemsIconAlignment, '!goog.soy.data.SanitizedContent|null|string|undefined');
  /** @type {!goog.soy.data.SanitizedContent|null|string|undefined} */
  var preferredAlign = soy.asserts.assertType(opt_data.preferredAlign == null || (goog.isString(opt_data.preferredAlign) || opt_data.preferredAlign instanceof goog.soy.data.SanitizedContent), 'preferredAlign', opt_data.preferredAlign, '!goog.soy.data.SanitizedContent|null|string|undefined');
  /** @type {*|null|undefined} */
  var toggle = opt_data.toggle;
  /** @type {!goog.soy.data.SanitizedContent|null|string|undefined} */
  var triggerAriaLabel = soy.asserts.assertType(opt_data.triggerAriaLabel == null || (goog.isString(opt_data.triggerAriaLabel) || opt_data.triggerAriaLabel instanceof goog.soy.data.SanitizedContent), 'triggerAriaLabel', opt_data.triggerAriaLabel, '!goog.soy.data.SanitizedContent|null|string|undefined');
  /** @type {!goog.soy.data.SanitizedContent|null|string|undefined} */
  var triggerClasses = soy.asserts.assertType(opt_data.triggerClasses == null || (goog.isString(opt_data.triggerClasses) || opt_data.triggerClasses instanceof goog.soy.data.SanitizedContent), 'triggerClasses', opt_data.triggerClasses, '!goog.soy.data.SanitizedContent|null|string|undefined');
  /** @type {!goog.soy.data.SanitizedContent|null|string|undefined} */
  var triggerTitle = soy.asserts.assertType(opt_data.triggerTitle == null || (goog.isString(opt_data.triggerTitle) || opt_data.triggerTitle instanceof goog.soy.data.SanitizedContent), 'triggerTitle', opt_data.triggerTitle, '!goog.soy.data.SanitizedContent|null|string|undefined');
  var dropdownElementClasses__soy21 = '';
  dropdownElementClasses__soy21 += 'dropdown-action';
  dropdownElementClasses__soy21 += elementClasses ? ' ' + elementClasses : '';
  var trigger__soy30 = function() {
    $templateAlias1({spritemap: spritemap, symbol: 'ellipsis-v'}, null, opt_ijData);
  };
  var param54 = '';
  if ((triggerTitle != null)) {
    param54 += triggerTitle;
  } else {
    var msg_2467__soy2468 = '';
    /** @desc  */
    var MSG_EXTERNAL_6305962755687847469 = goog.getMsg('actions');
    msg_2467__soy2468 += MSG_EXTERNAL_6305962755687847469;
    param54 += msg_2467__soy2468;
  }
  $templateAlias2({button: button, caption: caption, disabled: disabled, elementClasses: dropdownElementClasses__soy21, events: {buttonClicked: _handleButtonClick, itemClicked: _handleItemClick, toggle: toggle}, expanded: expanded, helpText: helpText, id: id, items: items, itemsIconAlignment: itemsIconAlignment, label: trigger__soy30, preferredAlign: preferredAlign, ref: 'dropdown', spritemap: spritemap, triggerAriaLabel: triggerAriaLabel, triggerClasses: triggerClasses, triggerTitle: param54}, null, opt_ijData);
}
exports.render = $render;
/**
 * @typedef {{
 *  items: !Array<?>,
 *  spritemap: (!goog.soy.data.SanitizedContent|string),
 *  _handleButtonClick: (*|null|undefined),
 *  _handleItemClick: (*|null|undefined),
 *  button: (?),
 *  caption: (!goog.soy.data.SanitizedContent|function()|null|string|undefined),
 *  disabled: (boolean|null|undefined),
 *  elementClasses: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  expanded: (boolean|null|undefined),
 *  helpText: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  id: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  itemsIconAlignment: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  preferredAlign: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  toggle: (*|null|undefined),
 *  triggerAriaLabel: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  triggerClasses: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  triggerTitle: (!goog.soy.data.SanitizedContent|null|string|undefined)
 * }}
 */
$render.Params;
if (goog.DEBUG) {
  $render.soyTemplateName = 'ClayActionsDropdown.render';
}

exports.render.params = ["items","spritemap","_handleButtonClick","_handleItemClick","button","caption","disabled","elementClasses","expanded","helpText","id","itemsIconAlignment","preferredAlign","toggle","triggerAriaLabel","triggerClasses","triggerTitle"];
exports.render.types = {"items":"list<?>","spritemap":"string","_handleButtonClick":"any","_handleItemClick":"any","button":"?","caption":"html|string","disabled":"bool","elementClasses":"string","expanded":"bool","helpText":"string","id":"string","itemsIconAlignment":"string","preferredAlign":"string","toggle":"any","triggerAriaLabel":"string","triggerClasses":"string","triggerTitle":"string"};
templates = exports;
return exports;

});

class ClayActionsDropdown extends Component {}
Soy.register(ClayActionsDropdown, templates);
export { ClayActionsDropdown, templates };
export default templates;
/* jshint ignore:end */
